module.exports = __webpack_public_path__ + "static/img/99特惠.a2bb551.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/center/99特惠.png
// module id = 60
// module chunks = 18